import { IListing } from "~/types/api-types";

import { ApiError } from "./api-error";

const updateListing = async ({
  listingId,
  accessToken,
  payload,
}: {
  listingId: string;
  accessToken: string;
  payload: Partial<IListing>;
}): Promise<IListing> => {
  const response = await fetch(`/v1/listings/${listingId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new ApiError(
      errorData.error || "Failed to update listing",
      response.status,
    );
  }

  const data = (await response.json()) as IListing;
  return data;
};

export { updateListing };
